<header>
    <h2>Job Automation</h2>
</header>

<div class="tabs">
    <button mat-button (click)="previousWeek()">Previous Week</button>
    <button *ngIf="weekOffset > 0" mat-button (click)="nextWeek()">Next Week</button>
    <div class="date-range">
        {{this.startDate | date}} to {{this.endDate | date}}
    </div>
</div>

<div class="container">

    <div class="left">
        <button mat-button (click)="createConsoleLogJob()">Create Console Log Job</button>
        <button mat-button (click)="createEmailJob()">Create Email Job</button>
        <button mat-button (click)="createSMSJob()">Create SMS Job</button>
        <button mat-button (click)="invoiceReminderJob()">Create Invoice Reminder Job</button>
        <button mat-button (click)="bankSyncJob()">Bank Sync Job</button>
        <button mat-button (click)="backupJob()">Backup Job</button>
    </div>


    <div class="right">

        <table class="invoices" mat-table [dataSource]="dataSource" multiTemplateDataRows>
             
            <!-- Column Headers -->
            <ng-container matColumnDef="state">
                <th class="status-header" mat-header-cell *matHeaderCellDef>State</th>
                <td class="status-column" mat-cell *matCellDef="let element">
                    <div class="status" [class]="element.state">
                        {{element.state}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th class="date" mat-header-cell *matHeaderCellDef>Date</th>
                <td class="date" mat-cell *matCellDef="let element"> {{element.date.start | date:'dd-MM-yy'}} </td>
            </ng-container>

            <ng-container matColumnDef="job">
                <th class="job-header" mat-header-cell *matHeaderCellDef>Job</th>
                <td (click)="openJobDialog(element)" class="job-column" mat-cell *matCellDef="let element">
                    {{element.job}}
                </td>
            </ng-container>

            <ng-container matColumnDef="log">
                <th class="log-header" mat-header-cell *matHeaderCellDef>Log</th>
                <td (click)="openJobDialog(element.log)" class="log-column" mat-cell *matCellDef="let element">
                    {{getLastLogEntry(element.log)}}
                </td>
            </ng-container>
        

        
            <tr class="invoice-row"
                mat-row
                *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;">
            </tr>
        </table>
    </div>
</div>